export default __webpack_public_path__ + "static/media/regulatory--no-heavy-goods-vehicles-motorcycles-or-bicycles--g1.37078248.png";